import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, ProgressBar, Badge, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';

const ProgressTracker = () => {
    const [progress, setProgress] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchProgress();
    }, []);

    const fetchProgress = async () => {
        try {
            const userId = localStorage.getItem('userId');
            const response = await axios.get(`/progress/user/${userId}/resume`);
            setProgress(response.data);
            setLoading(false);
        } catch (err) {
            setError('Er is een fout opgetreden bij het ophalen van je voortgang.');
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Laden...</span>
                </Spinner>
            </Container>
        );
    }

    return (
        <Container className="py-5">
            <h1 className="mb-4">Mijn Leervoortgang</h1>

            {error && (
                <Alert variant="danger" onClose={() => setError(null)} dismissible>
                    {error}
                </Alert>
            )}

            <Row xs={1} md={2} className="g-4">
                {progress.map((item) => (
                    <Col key={item.courseId}>
                        <Card className="h-100 shadow-sm">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">{item.courseTitle}</h5>
                                <Badge bg={item.progress === 100 ? 'success' : 'primary'}>
                                    {item.progress === 100 ? 'Voltooid' : 'In Progress'}
                                </Badge>
                            </Card.Header>
                            <Card.Body>
                                <Card.Title className="h6">Voortgang</Card.Title>
                                <ProgressBar
                                    now={item.progress}
                                    label={`${Math.round(item.progress)}%`}
                                    variant={item.progress === 100 ? 'success' : 'primary'}
                                    className="mb-3"
                                />
                                <div className="small text-muted">
                                    <div>Laatste activiteit: {new Date(item.lastActivity).toLocaleDateString()}</div>
                                    <div>Voltooide lessen: {item.completedLessons} / {item.totalLessons}</div>
                                </div>
                            </Card.Body>
                            <Card.Footer>
                                <small className="text-muted">
                                    Geschatte tijd tot voltooiing: {item.estimatedTimeRemaining} minuten
                                </small>
                            </Card.Footer>
                        </Card>
                    </Col>
                ))}
            </Row>

            {progress.length === 0 && (
                <Card className="text-center p-5">
                    <Card.Body>
                        <h4>Geen cursussen gestart</h4>
                        <p>Je hebt nog geen cursussen gestart. Ga naar de cursuslijst om te beginnen!</p>
                    </Card.Body>
                </Card>
            )}
        </Container>
    );
};

export default ProgressTracker;
